export default "__VITE_ASSET__ed4ef02c__"